module.exports = __webpack_public_path__ + "img/richeng.129617dd.png";